import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mdl-filter-contacts',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './mdl-filter-contacts.html',
  styleUrl: './mdl-filter-contacts.css'
})
export class MdlFilterContacts implements OnInit {
  constructor(
    public mdl: MatDialogRef<MdlFilterContacts>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.contactos) {
      this.extractFilterOptions(data.contactos);
    }
    if (data && data.filters) {
      this.filters = { ...this.filters, ...data.filters };
    }
  }

  availableAccounts: string[] = [];
  availableOwners: string[] = [];

  filters = {
    allAccounts: true,
    allOwners: true,  
    creationDateRange: 'all',   
    phoneFilter: 'all',
    emailFilter: 'all',   
    accounts: {} as { [key: string]: boolean },
    owners: {} as { [key: string]: boolean }
  };

  ngOnInit() {
    this.initializeCheckboxes();
  }

  private extractFilterOptions(contactos: any[]): void {
    
    const accountsSet = new Set<string>();
    const ownersSet = new Set<string>();

    contactos.forEach(contacto => {
      if (contacto.cuenta?.nombre_empresa) {
        accountsSet.add(contacto.cuenta.nombre_empresa);
      }
      
      if (contacto.ejecutivo) {
        const ownerName = `${contacto.ejecutivo.nombre} ${contacto.ejecutivo.apellido}`.trim();
        ownersSet.add(ownerName);
      }
    });

    this.availableAccounts = Array.from(accountsSet).sort();
    this.availableOwners = Array.from(ownersSet).sort();
  }

  private initializeCheckboxes(): void {
    this.availableAccounts.forEach(account => {
      if (this.filters.accounts[account] === undefined) {
        this.filters.accounts[account] = this.filters.allAccounts;
      }
    });

    this.availableOwners.forEach(owner => {
      if (this.filters.owners[owner] === undefined) {
        this.filters.owners[owner] = this.filters.allOwners;
      }
    });
  }

  toggleAllAccounts(): void {
    if (this.filters.allAccounts) {
      this.availableAccounts.forEach(account => {
        this.filters.accounts[account] = true;
      });
    } else {
      this.availableAccounts.forEach(account => {
        this.filters.accounts[account] = false;
      });
    }
  }

  onAccountChange(): void {
    const allAccountsSelected = this.availableAccounts.every(account => this.filters.accounts[account]);
    const anyAccountSelected = this.availableAccounts.some(account => this.filters.accounts[account]);
    
    this.filters.allAccounts = allAccountsSelected;
    
    if (!anyAccountSelected) {
      this.filters.allAccounts = true;
      this.toggleAllAccounts();
    }
  }

  toggleAllOwners(): void {
    if (this.filters.allOwners) {
      this.availableOwners.forEach(owner => {
        this.filters.owners[owner] = true;
      });
    } else {
      this.availableOwners.forEach(owner => {
        this.filters.owners[owner] = false;
      });
    }
  }

  onOwnerChange(): void {
    const allOwnersSelected = this.availableOwners.every(owner => this.filters.owners[owner]);
    const anyOwnerSelected = this.availableOwners.some(owner => this.filters.owners[owner]);
    
    this.filters.allOwners = allOwnersSelected;
    
    if (!anyOwnerSelected) {
      this.filters.allOwners = true;
      this.toggleAllOwners();
    }
  }

  clearFilters(): void {
    this.filters = {
      allAccounts: true,
      allOwners: true,
      creationDateRange: 'all',
      phoneFilter: 'all',
      emailFilter: 'all',
      accounts: {},
      owners: {}
    };
    
    this.initializeCheckboxes();
  }

  closeMdl(): void {
    this.mdl.close();
  }

  applyFilters(): void {
    this.mdl.close(this.filters);
  }
}